// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__1zmpK","periodSelect":"styles_periodSelect__yRV6s","textInput":"styles_textInput__2RXOQ"};